import WordBin from "./WordBin";
import { useState, useEffect } from "react";
import { useDrop } from "react-dnd";
import "./Goals.css";
import Goal from "./Goal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";

function Goals(props) {
  const [word1GoalArray, setWord1GoalArray] = useState([]);
  const [word2GoalArray, setWord2GoalArray] = useState([]);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [groupID, setGroupID] = useState();
  const [errorCheckingBorder1, setErrorCheckingBorder1] = useState("");
  const [errorCheckingBorder2, setErrorCheckingBorder2] = useState("");
  const [openModalOnce, setOpenModalOnce] = useState(false);
  const [wordBinArray, setWordBinArray] = useState([
    {
      id: 0,
      name: "",
      group: 0,
    },
  ]);
  const [goal1Array, setGoal1Array] = useState([
    {
      id: 1,
      name: "Animal",
      media: null,
      group: 1,
    },
  ]);

  const [goal2Array, setGoal2Array] = useState([
    {
      id: 2,
      name: "Food",
      media: null,
      group: 2,
    },
  ]);

  const [changeArrays, setChangeArrays] = useState(0);
  const [{ isOver }, goal] = useDrop(() => ({
    accept: ["word", "word2"],
    drop: (item) => addWordToGroup1(item.id, item.group, item.name),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const [{ isOver2 }, goal2] = useDrop(() => ({
    accept: ["word", "word1"],
    drop: (item) => addWordToGroup2(item.id, item.group, item.name),
    collect: (monitor) => ({
      isOver2: !!monitor.isOver(),
    }),
  }));

  const goalDataSetFromParent = () => {
    setGoalData(props.goalData)
  }

  useEffect(() => {
    goalDataSetFromParent()
  },[props.goalData])

  //settings
  const [timer, setTimer] = useState();
  const [errorChecking, setErrorChecking] = useState(true);
  const [allowImages, setAllowImages] = useState();
  const [goalData, setGoalData] = useState();

  /** 
  const handleSettings = async () => {
    const response = await makeGetRequest(
      urls.activitiesUserSettings,
      "",
      true
    );
    const settings = response.data[0];
    setAllowImages(settings.allow_images);
    setTimer(settings.timer);
    setErrorChecking(settings.error_checking);
  };

  useEffect(() => {
    handleSettings();
  }, []);*/

  const addWordToGroup1 = (id, group, name) => {
    if (group === 1) {
      setWord1GoalArray((word) => [
        ...word,
        {
          id: id,
          group: group,
          name: name,
        },
      ]);
      setChangeArrays(1);
    } else {
      setWord1GoalArray((word) => [
        ...word,
        {
          id: id,
          group: group,
          name: name,
        },
      ]);
      setIncorrectCount((prevCount) => prevCount + 1);
      setChangeArrays(1);
    }
  };

  const addWordToGroup2 = (id, group, name) => {
    if (group === 2) {
      const goalArray = wordBinArray.filter((word) => id === word.id);
      setWord2GoalArray((word) => [
        ...word,
        {
          id: id,
          group: group,
          name: name,
        },
      ]);
      setChangeArrays(2);
    } else {
      const goalArray = wordBinArray.filter((word) => id === word.id);
      setWord2GoalArray((word) => [
        ...word,
        {
          id: id,
          group: group,
          name: name,
        },
      ]);
      setIncorrectCount((prevCount) => prevCount + 1);
      setChangeArrays(2);
    }
  };

  useEffect(() => {
    if(goalData != undefined){
      goalDataSet()
    }
  },[goalData])

  const goalDataSet = () => {
    setGoal1Array({
      id: 1,
      name: goalData[0].group_name,
      media: null,
      group: 1,
    });
    setGoal2Array({
      id: 2,
      name: goalData[1].group_name,
      media: null,
      group: 2,
    });
    const groupData = goalData.filter((item) => {
      return item.category_sorts === groupID;
    });
    if(groupData.length > 0){
      const wordsGroup = groupData[0].words.map((word) => {
        return {
          id: Math.random() * 10,
          name: word,
          group: 1,
        };
      });
      const wordsGroup2 = groupData[1].words.map((word) => {
        return {
          id: Math.random() * 10,
          name: word,
          group: 2,
        };
      });
      wordsGroup.push(...wordsGroup2);
      const randomizeList = wordsGroup.sort(function () {
        return 0.5 - Math.random();
      });
      setWordBinArray(randomizeList);
    }else{
      const wordsGroup = goalData[0].words.map((word) => {
        return {
          id: Math.random() * 10,
          name: word,
          group: 1,
        };
      });
      const wordsGroup2 = goalData[1].words.map((word) => {
        return {
          id: Math.random() * 10,
          name: word,
          group: 2,
        };
      });
      wordsGroup.push(...wordsGroup2);
      const randomizeList = wordsGroup.sort(function () {
        return 0.5 - Math.random();
      });
      setWordBinArray(randomizeList);
    }
  }

  useEffect(() => {
    const goalArray = word1GoalArray.concat(word2GoalArray);
    setWordBinArray(
      wordBinArray.filter(
        (word) => !goalArray.some((goalWords) => goalWords.id === word.id)
      )
    );
    const goal1Correct = word1GoalArray.findIndex((x) => x.group === 2);
    const goal2Correct = word2GoalArray.findIndex((x) => x.group === 1);
    if (
      wordBinArray.length === 0 &&
      goal1Correct === -1 &&
      goal2Correct === -1
    ) {
      clearInterval(props.triggerTimer);
      props.timesPlayed((prevCount) => prevCount + 1);
      props.openGameStartModal(true);
    }
  }, [changeArrays]);

  useEffect(() => {
    const goal1Array = word2GoalArray.concat(wordBinArray);
    const goal2Array = word1GoalArray.concat(wordBinArray);
    if (changeArrays === 1) {
      setWord2GoalArray(
        word2GoalArray.filter(
          (word) => !goal2Array.some((goalWords) => goalWords.id === word.id)
        )
      );
    }
    if (changeArrays === 2) {
      setWord1GoalArray(
        word1GoalArray.filter(
          (word) => !goal1Array.some((goalWords) => goalWords.id === word.id)
        )
      );
    }
    setChangeArrays(0);
  }, [wordBinArray]);

  useEffect(() => {
    const errorCheckArray = word1GoalArray.map((x) => x.group === 2);
    if (
      errorChecking === true &&
      errorCheckArray.findIndex((x) => x === true) >= 0
    ) {
      setErrorCheckingBorder1("5px solid #9f0000a1");
    } else {
      setErrorCheckingBorder1("2px solid rgb(8 118 141)");
    }
  }, [errorChecking, wordBinArray, word1GoalArray]);

  useEffect(() => {
    const errorCheckArray = word2GoalArray.map((x) => x.group === 1);
    if (
      errorChecking === true &&
      errorCheckArray.findIndex((x) => x === true) >= 0
    ) {
      setErrorCheckingBorder2("5px solid #9f0000a1");
    } else {
      setErrorCheckingBorder2("2px solid rgb(8 118 141)");
    }
  }, [errorChecking, wordBinArray, word2GoalArray]);

  const resetGame = () => {
    setWord1GoalArray([]);
    setWord2GoalArray([]);
    //wordData();
    props.setTime(0);
    setIncorrectCount(0);
    props.onResetGame(0);
  };

  useEffect(() => {
    if (props.resetGame === 1) {
      resetGame();
    }
  }, [props.resetGame]);

  return (
    <div style={{ margin: "25px" }}>
      <Container fluid style={{marginLeft:'0px',marginRight:'0px'}}>
        {props.timer ? (
          <Card bg="light" style={{ marginBottom: "10px" }}>
            <Card.Body>Current Time: {props.time}</Card.Body>
          </Card>
        ) : (
          ""
        )}
        <Row>
          <Col style={{textAlign:'center'}}>
            <Goal
              goalArray={goal1Array}
              wordGoalArray={word1GoalArray}
              goal={goal}
              isOver={isOver}
              errorCheckBorder={errorCheckingBorder1}
              dragType={"word1"}
            />
          </Col>
          <Col style={{textAlign:'center'}}>
            <Goal
              goalArray={goal2Array}
              wordGoalArray={word2GoalArray}
              goal={goal2}
              isOver={isOver2}
              errorCheckBorder={errorCheckingBorder2}
              dragType={"word2"}
            />
          </Col>
        </Row>
        <Row style={{ minHeight: "150px",textAlign:'center', marginTop:'30px' }}>
          <WordBin words={wordBinArray} />
        </Row>
      </Container>
    </div>
  );
}

export default Goals;
